import * as React from 'react'
import { connect } from 'react-redux'
import { clearAlertBox } from '@App/actions/snackbar'

import './styles.scss'

interface Props {
  content: any
  clear: any
}

class Alert extends React.Component<Props> {
  constructor(props: any) {
    super(props)

    this.hide = this.hide.bind(this)
    this.customStyle = this.customStyle.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  hide(el: any) {
    const { clear } = this.props
    clear()
    el.classList.remove('isVisible')
  }

  customStyle() {
    const { content } = this.props

    if (content && content.background && typeof content.background === 'string') {
      return { backgroundColor: `${content.background}` }
    }

    return null
  }

  handleClick() {
    const el = document.querySelector('.alert')

    this.hide(el)
  }

  render() {
    const { content } = this.props
    const el = document.querySelector('.alert')

    if (el && content && Object.keys(content).length > 0) {
      el.classList.add('isVisible')
      setTimeout(() => {
        this.hide(el)
        // tslint:disable-next-line: align
      }, content.delay)
    }

    if (content) {
      return (
        <div
          className="alert"
          style={this.customStyle() as any}
        >
          {content?.title}
          <div
            role="button"
            tabIndex={0}
            className="alert__close"
            onClick={this.handleClick}
            onKeyDown={() => {
            }}
          />
        </div>
      )
    }

    return null
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    clear: () => dispatch(clearAlertBox()),
  }
}

export default connect(null, mapDispatchToProps)(Alert)
